import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/useAuthStore';
import PWPLogo from './PWPLogo';
import styles from './Sidebar.module.css';

const menuItems = {
    region_admin: [
        { label: 'إضافة تظاهرة', path: '/add-protest', icon: '＋' },
        { label: 'التظاهرات', path: '/protests', icon: '◉' },
        { label: 'الإعدادات', path: '/settings', icon: '🔗' },
    ],
    free_user: [
        { label: 'إضافة (AI)', path: '/add-protest', icon: '＋' },
        { label: 'إضافة يدوية', path: '/add-protest-manual', icon: '✎' },
        { label: 'التظاهرات', path: '/protests', icon: '◉' },
        { label: 'التقارير', path: '/reports', icon: '📋' },
        { label: 'الإعدادات', path: '/settings', icon: '🔗' },
    ],
    monitor: [
        { label: 'التظاهرات', path: '/protests', icon: '◉' },
        { label: 'الإعدادات', path: '/settings', icon: '🔗' },
    ],
    super_admin: [
        { label: 'إضافة (AI)', path: '/add-protest', icon: '＋' },
        { label: 'إضافة يدوية', path: '/add-protest-manual', icon: '✎' },
        { label: 'التظاهرات', path: '/protests', icon: '◉' },
        { label: 'الإحصائيات', path: '/stats', icon: '▦' },
        { label: 'التقارير', path: '/reports', icon: '📋' },
        { label: 'سلة المحذوفات', path: '/trash', icon: '🗑' },
        { label: 'لوحة الإدارة', path: '/admin', icon: '⚙' },
        { label: 'الإعدادات', path: '/settings', icon: '🔗' },
    ],
};

const roleLabels = {
    super_admin: 'مشرف عام',
    region_admin: 'مشرف منطقة',
    free_user: 'مستخدم',
    monitor: 'مراقب',
};

export default function Sidebar() {
    const user = useAuthStore((s) => s.user);
    const logout = useAuthStore((s) => s.logout);
    const navigate = useNavigate();
    const location = useLocation();

    const items = menuItems[user?.role] || menuItems.free_user;

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <aside className={`${styles.sidebar} text-ar`}>
            <div className={styles.logo}>
                <div className={styles.logoInner}>
                    <PWPLogo size={36} />
                    <div className={styles.logoText}>
                        <span className={styles.logoTitle}>PWP Tracker</span>
                        <span className={styles.logoSubtitle}>راصد الإرادة الشعبية</span>
                    </div>
                </div>
            </div>

            <nav className={styles.menu}>
                {items.map((item) => (
                    <button
                        key={item.path}
                        className={`${styles.menuItem} ${location.pathname === item.path ? styles.active : ''}`}
                        onClick={() => navigate(item.path)}
                    >
                        <span className={styles.icon}>{item.icon}</span>
                        <span>{item.label}</span>
                    </button>
                ))}
            </nav>

            <div className={styles.footer}>
                <div className={styles.userInfo}>
                    <div className={styles.avatar}>
                        {user?.name?.[0]?.toUpperCase()}
                    </div>
                    <div className={styles.userText}>
                        <p className={styles.userName}>{user?.name}</p>
                        <p className={styles.userRole}>{roleLabels[user?.role] || user?.role}</p>
                    </div>
                </div>
                <button className={styles.logoutBtn} onClick={handleLogout}>
                    تسجيل الخروج
                </button>
            </div>
        </aside>
    );
}
